import React from 'react';
import styles from '../Header/style/Header.module.scss';
import MenuButton from '../Header/components/MenuButton';
import HeaderLogo from '../Header/components/HeaderLogo';
import LinkButton from '../../common/Buttons/LinkButton';
import Notifications from '../Header/components/Notifications';
import ShoppingCartButton from '../Header/components/ShoppingCartButton';
import { ReactComponent as LockIcon } from '../../../assets/icon/Lock.svg'

interface NavigationItem {
  id: string;
  path?: string;
  href?: string;
  title: string;
}


const navigationItems: NavigationItem[] = [
    { id: 'Header-GetStarted_Button', path: '/features', title: 'GET STARTED' },
    { id: 'Header-Pricing_Button', path: '/pricing', title: 'Pricing' },
    { id: 'Header-Contact_Button', path: '/contact', title: 'Contact' },
    { id: 'Header-Api_Button', path: '/api', title: 'Api' },
  ];

const MockHeader: React.FC =  () => {
  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <HeaderLogo onClick={() => null} />

        {navigationItems.map((item) => (
          <MenuButton
            key={item.id}
            id={item.id}
            onClick={() => null}
            title={item.title}
            href={item.href}
          />
        ))}
      </div>

      <div className={styles.right}>
        <div className={styles.iconsContainer}>
          <LinkButton
            id="Header-Cart_Button"
            smallHide={true}
            onClick={() => null}
            aria-label="Shopping Cart"
          >
            <ShoppingCartButton />
          </LinkButton>

          <LinkButton
            id="Header-Notification_Button"
            smallHide={true}
            onClick={() => null}
            aria-label="Notifications"
          >
            <Notifications />
          </LinkButton>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',

            width: '32px',
            height: '32px',

            borderRadius: '50%',
            background: '#ffffff',
            margin: '10px',
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: '18px',
            color: '#09334b',
          }}
        >
          <LockIcon />
        </div>
      </div>
    </header>
  );
};

export default MockHeader;
    